import { render, staticRenderFns } from "./SearchBar.vue?vue&type=template&id=22e8bea7&scoped=true"
import script from "./SearchBar.vue?vue&type=script&lang=ts&setup=true"
export * from "./SearchBar.vue?vue&type=script&lang=ts&setup=true"
import style1 from "./SearchBar.vue?vue&type=style&index=1&id=22e8bea7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22e8bea7",
  null
  
)

export default component.exports